import { render, staticRenderFns } from "./RomfourEmployee.vue?vue&type=template&id=afffd4b0&"
import script from "./RomfourEmployee.vue?vue&type=script&lang=js&"
export * from "./RomfourEmployee.vue?vue&type=script&lang=js&"
import style0 from "./RomfourEmployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports